"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = new _immutable.Record({
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  roleIds: null,
  roleNames: null
}, 'User');

exports.default = _default;
module.exports = exports.default;